<template>
  <div v-if="refusedAd && !isEmptyObject(refusedAd)" class="refused-box"
       @click="jumpRiver"
       data-sensors-click
  >
    <div class="box-title">
      <div class="main-title">
        {{ refusedAd.productName }}
        <div class="title-tag">{{refusedAd.cornerWord}}</div>
      </div>
      <div class="sub-title">{{refusedAd.productDesc}}</div>
    </div>
    <div class="box-content">
      <div class="content-left">
        <p class="info">最高可借（元）</p>
        <p class="amount">{{refusedAd.configLimit | currency}}</p>
        <p class="rate">年化利率{{refusedAd.minPrice}}%-{{refusedAd.maxPrice}}%</p>
      </div>
      <div class="content-right">
        <div class="right-btn">{{refusedAd.buttonName}}</div>
      </div>
    </div>
    <div class="box-home" @click="jumpHome">去主页</div>
  </div>
  <div v-else :class="['empty-box', showPlace, isVipValidate?'isVipValidate': 'vipNotValidate']"
       data-sensors-click @click="toDetail"
  >
    <div class="box-home" @click.stop="jumpHome">去主页</div>
  </div>
</template>

<script>
import { isEmptyObject } from '@/assets/utils'
import { mapActions } from 'vuex'

export default {
  name: 'refused-box',
  props: {
    source: {
      type: String,
      default: ''
    },

    showPlace: {
      type: String,
      default: ''
    },
    refusedAd: {
      type: Object,
      default: () => ({})
    },
    step: {
      type: String,
      default: ''
    },
    isVipValidate: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      applyNo: this.$route.query.applyNo
    }
  },
  watch: {
    refusedAd: {
      immediate: true,
      deep: true,
      handler (val) {
        this.$sensors.track('Diversion_Exposure', { product_type: 'diversion', page_status: this.step, element_positon: 'product_banner', product_code: val.configId })
      }

    }
  },

  methods: {
    isEmptyObject,
    ...mapActions('user', ['getBorrowList']),
    // 跳转导流主页1
    jumpRiver () {
      this.$sensors.track('Diversion_Click', { product_type: 'diversion', page_status: this.step, element_positon: 'product_banner', product_code: this.refusedAd.configId })
      this.$report({
        id: 10510,
        args: {
          target: this.refusedAd.configId,
          status: this.showPlace === 'CREDIT_RESULT' ? 'credit' : 'loan'
        }
      })
      this.$router.push({ path: '/river/middle', query: { ...this.refusedAd, directionUrl: encodeURIComponent(this.refusedAd.directionUrl), source: encodeURIComponent(this.source) } })
    },
    toDetail () {
      if ((!this.refusedAd || isEmptyObject(this.refusedAd)) && this.isVipValidate) {
        return
      }
      this.$report({
        id: 10510,
        args: {
          target: this.showPlace === 'CREDIT_RESULT' ? 'credit_card' : 'loan_card',
          status: this.showPlace === 'CREDIT_RESULT' ? 'credit' : 'loan'
        }
      })
      this.jumpToKingCardPage()
    },
    jumpHome (e) {
      e.stopPropagation()
      this.$router.push('/river/diversion')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.refused-box{
  width: 671px;
  height: 394px;
  background: url(./images/img_kuang@2x.png) center no-repeat;
  background-size: 100%;
  position: relative;
  color: #FFFFFF;
  margin-left: auto;
  margin-right: auto;
  padding: 62px 30px;
  .box-title{
    border-bottom: 1PX dashed #FFFFFF;
    padding-bottom: 17px;
    .main-title{
      display: flex;
      align-items: center;
      font-size: 36px;
      line-height: 50px;
      font-weight: bold;
      .title-tag{
        background-color: #2048C6;
        border-radius: 8px;
        font-size: 20px;
        padding: 0 8px;
        margin-left: 10px;
        line-height: 30px;
      }
    }
    .sub-title{
      font-size: 20px;
      line-height: 28px;
    }
  }
  .box-content{
    padding-top: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .content-left{
      .info{
        font-size: 20px;
        color: #ADC2FF;
        line-height: 28px;
      }
      .amount{
        font-family: DIN-Medium, DIN;
        font-size: 70px;
        line-height: 85px;
        margin-top: -5px;
      }
      .rate{
        color: #F6F8FF;
        font-size: 20px;
        line-height: 28px;
        margin-top: 13px;
      }
    }
    .content-right{
      .right-btn{
        width: 240px;
        height: 70px;
        line-height: 70px;
        background-color: #fff;
        border-radius: 47px;
        font-size: 28px;
        font-weight: bold;
        color: #4B70FE;
        text-align: center;
      }
    }
  }

}
.box-home{
    font-size: 28px;
    color: #BBBBBB;
    position: absolute;
    line-height: 40px;
    top: 0;
    right: 10px;
    text-decoration: underline;
  }
.empty-box{
  margin: 0 auto;
  position: relative;
  width: 672px;
  height: 395px;
  &.LOAN_RESULT {

    &.isVipValidate {
      background: url(./images/withdraw_refused.png) no-repeat center center;
      background-size: contain;
    }
    &.vipNotValidate {
      background: url(./images/banner_card2.png) no-repeat center center;
      background-size: contain;
    }
  }
  &.CREDIT_RESULT {
    &.isVipValidate {
      background: url(./images/credit_refused.png) no-repeat center center;
      background-size: contain;
    }
    &.vipNotValidate {
      background: url(./images/banner_king@2x.png) no-repeat center center;
      background-size: contain;
    }
  }
}
</style>